module.exports = __webpack_public_path__ + "img/ind-jxyr.5977dd03.png";